<template>
  <div v-if="abierto" class="cgd" @click.self="$emit('cancelar')" @keydown.esc="$emit('cancelar')">
    <!-- Cabecera, cuerpo y pie: lo único que se desplaza es el cuerpo, en vertical, para que
         «Cancelar» y «Guardar en la línea» estén siempre a la vista (Dirección, 26/10/2026). -->
    <div class="cgd-dlg" role="dialog" aria-modal="true" aria-labelledby="cgd-t">
      <div class="cgd-h">
        <h3 id="cgd-t">{{ titulo }}</h3>
        <p class="cdn-note" style="margin-top:0">Esto es lo que se escribe en la línea. Hasta que no lo confirmes, la oferta no cambia.</p>
      </div>
      <div class="cgd-b">
        <div v-if="faltan.length" class="cdn-state miss" style="margin:0 0 10px"><span class="ico">!</span><div><b>El precio sale incompleto</b><span class="cdn-note">{{ faltan.join(' · ') }}</span></div></div>
        <table class="cgd-t">
          <tr v-for="(f, i) in filas" :key="i"><th scope="row">{{ f.k }}</th><td>{{ f.v }}</td></tr>
        </table>
        <p class="cdn-note">Se guarda también todo lo tecleado, para que al reabrir la calculadora desde la línea el cálculo salga tal y como quedó.</p>
      </div>
      <div class="cgd-f">
        <button ref="no" class="cdn-btn" type="button" @click="$emit('cancelar')">Cancelar</button>
        <button ref="si" class="cdn-btn solid" type="button" @click="$emit('confirmar')">Guardar en la línea</button>
      </div>
    </div>
  </div>
</template>

<script>
/**
 * La confirmación de «Guardar en línea». Las `filas` las monta quien guarda A PARTIR DEL MISMO objeto
 * que luego se escribe en la línea: si se calcularan aparte, el diálogo podría prometer una cifra y
 * la línea quedarse con otra.
 */
export default {
  props: {
    abierto: { type: Boolean, default: false },
    titulo: { type: String, default: 'Guardar en la línea de la oferta' },
    filas: { type: Array, default: function () { return []; } },
    faltan: { type: Array, default: function () { return []; } }
  },
  watch: {
    abierto: function (v) {
      if (!v) {
        this.devolverDesplazamientos();
        return;
      }
      this.$nextTick(function () {
        this.desplazamientos = this.anotarDesplazamientos();
        // El foco va al botón de confirmar, como en la maqueta: se puede cerrar con Escape o Cancelar.
        // Sin `preventScroll`, el navegador desplaza la raíz de la aplicación para enseñar el botón,
        // y como la raíz no tiene barra, la oferta se queda descolocada al cerrar (Dirección, 27/10/2026).
        if (this.$refs.si) this.$refs.si.focus({ preventScroll: true });
      });
    }
  },
  beforeDestroy: function () {
    this.devolverDesplazamientos();
  },
  methods: {
    /**
     * Dónde estaba cada contenedor por encima del diálogo al abrirlo. Los navegadores que no
     * entienden `preventScroll` desplazan igual; lo que se mueva mientras el diálogo está abierto se
     * devuelve a su sitio al cerrarlo.
     */
    anotarDesplazamientos: function () {
      const anotados = [];
      for (let el = this.$el && this.$el.parentNode; el && el.nodeType === 1; el = el.parentNode) {
        anotados.push({ el: el, top: el.scrollTop, left: el.scrollLeft });
      }
      return anotados;
    },
    devolverDesplazamientos: function () {
      const anotados = this.desplazamientos || [];
      this.desplazamientos = null;
      anotados.forEach(function (a) {
        if (a.el.scrollTop !== a.top) a.el.scrollTop = a.top;
        if (a.el.scrollLeft !== a.left) a.el.scrollLeft = a.left;
      });
    }
  }
};
</script>

<style scoped>
.cgd{position:fixed;top:0;right:0;bottom:0;left:0;z-index:12000;display:flex;justify-content:center;align-items:center;padding:12px;background:rgba(3,14,28,.45);overflow:hidden}
/* Ancho hasta el 90 % de la ventana, con tope: los importes, los minutos y las versiones tienen que
   leerse enteros. Nada se sale a lo ancho; lo que no quepa en una línea, baja a la siguiente. En alto
   no pasa nunca del hueco que tiene, y las filas van apretadas para que a 1366×768 entre entero sin
   desplazar (Dirección, 27/10/2026). */
.cgd-dlg{background:var(--surface);color:var(--fg);border-radius:12px;width:90%;max-width:960px;max-height:100%;display:flex;flex-direction:column;overflow:hidden;box-shadow:0 12px 40px rgba(3,14,28,.35)}
.cgd-h{flex:none;padding:16px 22px 8px}
.cgd-h h3{font-family:var(--f-display);margin:0 0 2px;font-size:16px}
.cgd-b{flex:1 1 auto;min-height:0;overflow-x:hidden;overflow-y:auto;-webkit-overflow-scrolling:touch;padding:2px 22px 10px}
.cgd-t{width:100%;table-layout:fixed;border-collapse:collapse;font-size:13.5px}
.cgd-t th,.cgd-t td{padding:6px;border-bottom:1px solid var(--line);vertical-align:top;white-space:normal;word-wrap:break-word;overflow-wrap:break-word}
.cgd-t th{width:42%;color:var(--muted);text-align:left;font-weight:400}
.cgd-t td{text-align:right;font-family:var(--f-mono);font-variant-numeric:tabular-nums}
.cgd-f{flex:none;display:flex;justify-content:flex-end;padding:10px 22px 12px;border-top:1px solid var(--line);background:var(--surface)}
.cgd-dlg .cgd-f .cdn-btn{padding:8px 16px;font-size:13px}
.cgd-dlg .cgd-f .cdn-btn + .cdn-btn{margin-left:8px}
@media (max-width:640px){
  .cgd{padding:8px}
  .cgd-dlg{width:100%;max-height:100%}
  .cgd-h,.cgd-b,.cgd-f{padding-left:14px;padding-right:14px}
  .cgd-t th{width:48%}
}
</style>
